/* ============================================================================
   Studio Next add-ons. Runs on top of studio-next.js through window.SMN and
   never edits the builder's own code paths.
     • Layers panel           • Credit card for scale    • Actual size (+ calibration)
     • Peel & shine preview   • Qty nudge + arrival date • Print check chip
     • Paste / drop anywhere  • Keyboard shortcuts       • Toasts instead of alert()
   ========================================================================== */
/* overlays live in #smnLayer, not directly in <body>: the builder CSS resets padding/transform/max-width on
   every direct body child, which breaks centred pop-ups */
window.smnLayer = window.smnLayer || function () { var l = document.getElementById('smnLayer'); if (!l) { l = document.createElement('div'); l.id = 'smnLayer'; document.body.appendChild(l); } return l; };
(function () {
  'use strict';
  function start() {
    var SMN = window.SMN; if (!SMN) return;
    var CFG = Object.assign({ productionDays: 3, shipMin: 3, shipMax: 5 }, window.SMN_CONFIG || {});
    var S = SMN.state;
    var area = document.querySelector('.sms-canvas-area');
    if (!area) return;
    if (getComputedStyle(area).position === 'static') area.style.position = 'relative';

    // ── helpers ──────────────────────────────────────────────────────────────
    function $(s, r) { return (r || document).querySelector(s); }
    function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function money(n) { return '$' + n.toFixed(2); }
    function mk(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
    var IC = {
      layers: '<path d="m12 3 9 5-9 5-9-5 9-5z"/><path d="m3 13 9 5 9-5"/>',
      up: '<path d="m6 15 6-6 6 6"/>', down: '<path d="m6 9 6 6 6-6"/>',
      trash: '<path d="M4 7h16M10 11v6m4-6v6M6 7l1 13h10l1-13M9 7V4h6v3"/>',
      chev: '<path d="m6 9 6 6 6-6"/>', card: '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="M2.5 10h19"/>',
      ruler: '<path d="M3 17 17 3l4 4L7 21z"/><path d="m7 13 2 2m1-5 2 2m1-5 2 2"/>',
      peel: '<path d="M4 4h16v9l-7 7H4z"/><path d="M13 20v-7h7"/>', x: '<path d="M6 6l12 12M18 6 6 18"/>',
      check: '<path d="m5 12 5 5L20 7"/>', warn: '<path d="M12 9v4m0 4h.01M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>',
      truck: '<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/>',
      phone: '<rect x="7" y="2" width="10" height="20" rx="2"/><path d="M11 18h2"/>'
    };
    function ic(n) { return '<svg class="smx-i" viewBox="0 0 24 24" aria-hidden="true">' + IC[n] + '</svg>'; }
    var isTouch = window.matchMedia && matchMedia('(pointer:coarse)').matches;

    // ── toasts (replace alert() on this page) ────────────────────────────────
    var tbox = el('<div class="smx-toasts" aria-live="polite"></div>'); window.smnLayer().appendChild(tbox);
    function show(node) { node.hidden = false; node.style.removeProperty('display'); }
    function toast(msg, kind, action) {
      tbox.style.removeProperty('display');
      var t = el('<div class="smx-toast ' + (kind || '') + '">' + ic(kind === 'warn' ? 'warn' : 'check') + '<span>' + esc(msg) + '</span>' + (action ? '<button class="smx-link">' + esc(action.label) + '</button>' : '') + '</div>');
      if (action) t.querySelector('button').onclick = function () { action.fn(); t.remove(); };
      tbox.appendChild(t);
      setTimeout(function () { t.classList.add('out'); setTimeout(function () { t.remove(); }, 300); }, action ? (action.ms || 6500) : 4200);
    }
    window.alert = function (m) { toast(String(m == null ? '' : m), 'warn'); };
    window.SMNX = { toast: toast };

    // ── canvas tracking ──────────────────────────────────────────────────────
    var boundCanvas = null, listeners = [];
    function onCanvasChange(fn) { listeners.push(fn); }
    var bumpT = 0;
    function bump() { cancelAnimationFrame(bumpT); bumpT = requestAnimationFrame(function () { listeners.forEach(function (f) { try { f(); } catch (e) { console.warn('[smx]', e); } }); }); }
    function track() {
      var c = S.canvas;
      if (c && c !== boundCanvas) {
        boundCanvas = c;
        ['object:added', 'object:removed', 'object:modified', 'selection:created', 'selection:updated', 'selection:cleared', 'text:changed'].forEach(function (ev) { c.on(ev, bump); });
      }
      if (!c && boundCanvas) boundCanvas = null;
    }
    setInterval(function () { track(); bump(); }, 700); // renders are signature-checked, so this is cheap
    track();

    function userLayers() {
      if (!S.canvas) return [];
      return S.canvas.getObjects().filter(function (o) { return !o._isCutline && !o._isCutEdge && !o._isScissorIcon && o.visible !== false; });
    }
    function layerName(o) {
      if (o.type === 'i-text' || o.type === 'text' || o.type === 'textbox') return (o.text || 'Text').split('\n')[0].slice(0, 28) || 'Text';
      if (o._isTemplateBg) return 'Template background';
      if (o._dtfName) return String(o._dtfName).slice(0, 28);
      if (o.type === 'image') return 'Image';
      return o.type === 'path' || o.type === 'group' ? 'Clipart' : 'Shape';
    }
    var thumbs = new WeakMap(), ethumbs = new WeakMap();
    function thumbKey(o) { return (o.type === 'image' && o.getElement ? (o.getElement().src || '').slice(-40) : '') + o.width + 'x' + o.height + (o.fill || ''); }
    function thumbEl(o) { return o.type === 'image' && o.getElement && o.getElement() || null; }
    function thumbHit(o, key) { var e = thumbEl(o), a = thumbs.get(o), b = e && ethumbs.get(e); return a && a.key === key && a.e === e ? a : b && b.key === key ? b : null; }
    function thumbOf(o) {
      var key = thumbKey(o), e = thumbEl(o);
      var hit = thumbHit(o, key); if (hit) { thumbs.set(o, hit); return hit.url; }
      var url = '';
      try {
        if (o.type === 'image' && o.getElement) {
          var e = o.getElement(), w = e.naturalWidth || e.width, h = e.naturalHeight || e.height, k = 44 / Math.max(w, h, 1), c = mk(w * k, h * k);
          c.getContext('2d').drawImage(e, 0, 0, c.width, c.height); url = c.toDataURL('image/png');
        } else url = o.toDataURL({ format: 'png', multiplier: 44 / Math.max(o.getScaledWidth(), o.getScaledHeight(), 1) });
      } catch (err) { url = ''; }
      thumbs.set(o, hit = { key: key, url: url, e: e }); if (e) ethumbs.set(e, hit);
      return url;
    }

    // ── LAYERS PANEL ─────────────────────────────────────────────────────────
    var lp = el('<div class="smx-layers" id="smxLayers" hidden><button class="smx-layers-h" id="smxLayersH" aria-expanded="true">' + ic('layers') + '<span>Layers</span><b id="smxLayersN">0</b>' + ic('chev') + '</button><div class="smx-layers-list" id="smxLayersList"></div></div>');
    (document.querySelector('.ds-layers-side') || area).prepend(lp);
    var open = !isTouch && window.innerWidth > 900;
    lp.classList.toggle('open', open);
    $('#smxLayersH').onclick = function () { open = !open; lp.classList.toggle('open', open); this.setAttribute('aria-expanded', open); };
    var listSig = '', listAct = -1, thObjs = {};
    var thIO = window.IntersectionObserver ? new IntersectionObserver(function (es) {
      es.forEach(function (en) { var im = en.target, o = thObjs[im.dataset.th]; if (!en.isIntersecting) return; thIO.unobserve(im); if (o) im.src = thumbOf(o); });
    }, { root: $('#smxLayersList'), rootMargin: '150px 0px' }) : null;
    function renderLayers() {
      var ls = userLayers(), c = S.canvas, act = c && c.getActiveObject();
      lp.hidden = !ls.length;
      $('#smxLayersN').textContent = ls.length;
      var sig = ls.map(function (o, i) { return layerName(o) + i + (o.fill || '') + (o.type === 'image' ? thumbKey(o) : ''); }).join('|'), ai = ls.indexOf(act);
      if (sig === listSig) {
        if (ai !== listAct) { listAct = ai; $$('#smxLayersList .smx-row.on').forEach(function (r) { r.classList.remove('on'); }); var ar = ai > -1 && $('#smxLayersList .smx-row[data-i="' + ai + '"]'); if (ar) ar.classList.add('on'); }
        return;
      }
      listSig = sig; listAct = ai;
      var lazy = {};
      var rows = ls.slice().reverse().map(function (o, j) {
        var idx = ls.length - 1 - j, isText = /text/.test(o.type), th0 = isText ? null : thumbHit(o, thumbKey(o));
        if (!isText && !th0 && thIO) lazy[idx] = o;
        var th = isText ? '<span class="smx-lt" style="font-family:' + esc(o.fontFamily || 'sans-serif') + ';color:' + esc(typeof o.fill === 'string' ? o.fill : '#141a24') + '">Aa</span>' : '<img alt="" ' + (lazy[idx] ? 'data-th="' + idx + '"' : 'src="' + (th0 ? th0.url : thumbOf(o)) + '"') + '>';
        return '<div class="smx-row' + (o === act ? ' on' : '') + '" data-i="' + idx + '"><button class="smx-row-main" data-act="sel"><span class="smx-th">' + th + '</span><span class="smx-nm">' + esc(layerName(o)) + '</span></button>' +
          '<button class="smx-ib" data-act="up" title="Bring forward" ' + (idx === ls.length - 1 ? 'disabled' : '') + '>' + ic('up') + '</button>' +
          '<button class="smx-ib" data-act="down" title="Send backward" ' + (idx === 0 ? 'disabled' : '') + '>' + ic('down') + '</button>' +
          '<button class="smx-ib" data-act="del" title="Delete">' + ic('trash') + '</button></div>';
      });
      if (thIO) thIO.disconnect(); thObjs = lazy;
      $('#smxLayersList').innerHTML = rows.join('');
      if (thIO) $$('#smxLayersList img[data-th]').forEach(function (im) { thIO.observe(im); });
    }
    function afterReorder() {
      var c = S.canvas; if (!c) return;
      try { if (S.shape === 'die-cut') SMN.drawCutline(); else SMN.redraw(); } catch (e) { }
      c.renderAll(); SMN.save(); listSig = ''; bump();
    }
    $('#smxLayersList').addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var row = b.closest('.smx-row'), ls = userLayers(), i = +row.dataset.i, o = ls[i], c = S.canvas;
      if (!o || !c) return;
      var act = b.dataset.act;
      if (act === 'sel') { SMN.unlock(o); listSig = ''; bump(); }
      else if (act === 'del') { SMN.unlock(o); SMN.del(); listSig = ''; bump(); }
      else if (act === 'up' || act === 'down') {
        var nb = ls[act === 'up' ? i + 1 : i - 1]; if (!nb) return;
        c.moveTo(o, c.getObjects().indexOf(nb)); afterReorder();
      }
    });
    onCanvasChange(renderLayers);

    // ── SCALE TOOLS: credit card + actual size ───────────────────────────────
    var tools = el('<div class="smx-tools" id="smxTools" hidden>' +
      '<button class="smx-tg" id="smxActualT" title="Show your sticker at its real-world size">' + ic('ruler') + '<span>Actual size</span></button>' +
      '<button class="smx-tg" id="smxCalT" title="Calibrate actual size for this screen">' + ic('card') + '<span>Calibrate</span></button>' +
      '<button class="smx-tg smx-tg-hot" id="smxPeelT" title="Peel it and see the finish">' + ic('peel') + '<span>Peel &amp; preview</span></button></div>');
    area.appendChild(tools);
    function calPPI() { try { var v = parseFloat(localStorage.getItem('smx_ppi')); if (v > 40) return v; } catch (e) { } return 0; }
    function screenInfo() {
      var c = S.canvas; if (!c || !SMN.vo().length) return null;
      var lip = SMN.lip(); if (!lip || !lip.width) return null;
      var r = c.upperCanvasEl.getBoundingClientRect(), k = r.width / c.getWidth();
      var inches = S.sizeInches || 2, maxPx = Math.max(lip.width, lip.height) * k;
      return { ppi: maxPx / inches, rect: { left: r.left + lip.left * k, top: r.top + lip.top * k, width: lip.width * k, height: lip.height * k } };
    }
    // when the canvas area is too narrow for the layers card and the tools bar side by side, drop the layers card below the tools
    // phones: the canvas area starts behind the site header + specs summary bar, so start our chrome below them
    function chromeTop() {
      var ar = area.getBoundingClientRect(), t = 12;
      ['#sl2SpecsPill', '#shopify-section-header header', 'header.header', '.header-wrapper'].forEach(function (sel) {
        var e = document.querySelector(sel); if (!e || !e.getClientRects().length || getComputedStyle(e).visibility === 'hidden') return; // offsetParent is null for fixed elements
        var r = e.getBoundingClientRect(); if (r.height > 0 && r.top < ar.top + 220 && r.bottom > ar.top) t = Math.max(t, r.bottom - ar.top + 8);
      });
      return t;
    }
    function fitChrome() {
      tools.style.top = chromeTop() + 'px';
      if (tools.hidden || lp.hidden) { lp.style.top = tools.hidden ? tools.style.top : ''; return; }
      var ar = area.getBoundingClientRect(), tr = tools.getBoundingClientRect();
      // the layers card sits at left:12px and is lp.offsetWidth wide; stack it under the tools if they would touch
      var overlap = ar.left + 12 + lp.offsetWidth + 8 > tr.left;
      lp.style.top = overlap ? (tr.bottom - ar.top + 8) + 'px' : '';
    }
    setInterval(fitChrome, 400); window.addEventListener('resize', fitChrome);
    // phones: the Rotate/Done bar is position:fixed but sits inside #previewArea, which traps it mid-screen.
    // Move it next to the bottom toolbar so it pins above the toolbar as the CSS intends.
    (function () {
      var ab = document.getElementById('adjustBar'), tb = document.getElementById('sl2Toolbar');
      if (!ab || !tb || !window.matchMedia('(max-width: 768px)').matches) return;
      tb.parentNode.insertBefore(ab, tb);
      // keep it above the builder's own edit bar (Rotate/Flip/Front/Undo/Delete) when that bar is showing
      setInterval(function () {
        var ctx = document.getElementById('sl2CtxBar'), r = ctx && ctx.getClientRects().length ? ctx.getBoundingClientRect() : null;
        if (r && r.height > 0 && getComputedStyle(ctx).visibility !== 'hidden') ab.style.setProperty('bottom', (window.innerHeight - r.top + 8) + 'px', 'important');
        else ab.style.removeProperty('bottom');
      }, 250);
    })();
    $('#smxCalT').onclick = function () { openCal(function () { if (screenInfo()) actualSize(); else toast('Calibrated. Actual size will now match this screen.', 'ok'); }); };
    $('#smxActualT').onclick = function () { if (!calPPI()) return openCal(actualSize); actualSize(); };
    function actualSize() {
      var inf = screenInfo(); if (!inf) return toast('Add your art first.', 'warn');
      var target = calPPI(), z = SMN.getZoom() * target / inf.ppi;
      if (z > 3.5) { toast('Too big to show at real size on this screen. Showing as large as it fits.', 'warn'); z = 3.5; }
      SMN.setZoom(clamp(z, 0.15, 3.5));
      $('#smxActualT').classList.add('on'); setTimeout(function () { $('#smxActualT').classList.remove('on'); }, 1600);
      toast('Shown at real size: ' + (S.sizeInches || 2) + '″ on its longest side.', 'ok', { label: 'Recalibrate', fn: function () { openCal(actualSize); } });
    }
    // calibration modal: match the short edge of a bank card (2.125")
    var cal = el('<div class="smx-modal" hidden><div class="smx-modal-c"><button class="smx-ib smx-x" data-close aria-label="Close">' + ic('x') + '</button><h2>Calibrate actual size</h2><p>Hold the <b>short edge</b> of any bank or ID card against your screen. Drag the slider until the bar matches it exactly. You only do this once.</p><div class="smx-cal-wrap"><div class="smx-cal-bar" id="smxCalBar"><span>2.125″ card edge</span></div></div><input type="range" id="smxCalR" min="100" max="700" step="1" aria-label="Bar length"><div class="smx-modal-a"><button class="smx-btn" data-close>Cancel</button><button class="smx-btn smx-btn-p" id="smxCalOk">Save</button></div></div></div>');
    window.smnLayer().appendChild(cal);
    var calThen = null;
    function openCal(then) { calThen = then; var w = Math.round((calPPI() || (isTouch ? 150 : 96)) * 2.125); $('#smxCalR').value = w; $('#smxCalBar').style.width = w + 'px'; show(cal); }
    $('#smxCalR').oninput = function () { $('#smxCalBar').style.width = this.value + 'px'; };
    $('#smxCalOk').onclick = function () { try { localStorage.setItem('smx_ppi', String(+$('#smxCalR').value / 2.125)); } catch (e) { } cal.hidden = true; if (calThen) calThen(); };
    cal.addEventListener('click', function (e) { if (e.target === cal || e.target.closest('[data-close]')) cal.hidden = true; });
    onCanvasChange(function () { tools.hidden = !SMN.vo().length; });

    // ── PEEL & SHINE PREVIEW ─────────────────────────────────────────────────
    var pv = el('<div class="smx-pv" hidden><div class="smx-pv-top"><div class="smx-pv-t"><b>Preview</b><span id="smxPvHint"></span></div>' +
      '<div class="smx-pv-fin" id="smxPvFin"><button data-f="matte">Matte</button><button data-f="glossy">Glossy</button><button data-f="holographic">Holo</button></div>' +
      '<div class="smx-pv-r"><button class="smx-btn" id="smxPvTilt" hidden>' + ic('phone') + 'Tilt</button><button class="smx-btn" id="smxPvPeel">' + ic('peel') + 'Peel it</button><button class="smx-ib smx-pv-x" id="smxPvX" aria-label="Close preview">' + ic('x') + '</button></div></div>' +
      '<canvas id="smxPvCv"></canvas></div>');
    window.smnLayer().appendChild(pv);
    var P = { img: null, sil: null, back: null, liner: null, raf: 0, W: 0, H: 0, dpr: 1, lx: 0.3, ly: -0.2, tlx: 0.3, tly: -0.2, last: 0, t0: 0, peel: 0, fx: 0, fy: 0, anim: null, drag: false, rect: null, sparkle: null };
    var pcv = $('#smxPvCv'), pctx = pcv.getContext('2d');
    function silOf(img, color) { var c = mk(img.width, img.height), x = c.getContext('2d'); x.drawImage(img, 0, 0); x.globalCompositeOperation = 'source-in'; x.fillStyle = color; x.fillRect(0, 0, c.width, c.height); return c; }
    async function openPreview() {
      var bytes = null;
      try { bytes = await SMN.capture(); } catch (e) { bytes = null; }
      if (!bytes) return toast('Add your art first.', 'warn');
      var url = URL.createObjectURL(new Blob([bytes], { type: 'image/png' })), img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        P.img = img; P.sil = silOf(img, S.borderColor || '#ffffff'); P.back = silOf(img, '#eef0f3');
        var ln = silOf(img, '#f4f6f9'), lx = ln.getContext('2d'); lx.globalCompositeOperation = 'source-atop'; lx.strokeStyle = 'rgba(40,147,242,.16)'; lx.lineWidth = img.width / 160;
        for (var i = -img.width; i < img.width * 2; i += img.width / 28) { lx.beginPath(); lx.moveTo(i, 0); lx.lineTo(i + img.height, img.height); lx.stroke(); }
        lx.fillStyle = 'rgba(0,122,255,.35)'; lx.font = '700 ' + Math.round(img.width / 20) + 'px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'; lx.textAlign = 'center';
        for (var yy = img.height * 0.2; yy < img.height; yy += img.height * 0.28) for (var xx = img.width * 0.2; xx < img.width; xx += img.width * 0.4) lx.fillText('stickermint', xx, yy);
        P.liner = ln;
        show(pv); document.documentElement.classList.add('smx-lock');
        syncFin(); sizePv(); P.t0 = performance.now(); P.enter = P.t0;
        $('#smxPvHint').textContent = isTouch ? 'Drag the corner to peel' : 'Move your mouse to catch the light · drag the corner to peel';
        setTimeout(demoPeel, 900);
        loop();
      };
      img.src = url;
    }
    function closePreview() { pv.hidden = true; document.documentElement.classList.remove('smx-lock'); cancelAnimationFrame(P.raf); P.raf = 0; }
    function syncFin() { $$('#smxPvFin button').forEach(function (b) { b.classList.toggle('on', b.dataset.f === S.finish); }); }
    function sizePv() {
      var r = pcv.getBoundingClientRect(); P.dpr = Math.min(2, window.devicePixelRatio || 1); P.W = r.width; P.H = r.height;
      pcv.width = Math.round(P.W * P.dpr); pcv.height = Math.round(P.H * P.dpr);
      var img = P.img, inches = S.sizeInches || 2, maxSide = Math.max(img.width, img.height);
      var ppi = calPPI(), fit = Math.min((P.W - 80) / img.width, (P.H - 120) / img.height), s = fit;
      if (ppi) { var real = ppi * inches / maxSide; if (real < fit) s = real; }
      var w = img.width * s, h = img.height * s;
      P.rect = { x: (P.W - w) / 2, y: (P.H - h) / 2 + 10, w: w, h: h, ppi: maxSide * s / inches };
      P.fx = P.rect.x + w; P.fy = P.rect.y + h;
    }
    function corner() { return [P.rect.x + P.rect.w, P.rect.y + P.rect.h]; }
    function halfPlane(M, n, side) {
      var L = 6000, t = [-n[1], n[0]], p = new Path2D();
      p.moveTo(M[0] + t[0] * L, M[1] + t[1] * L); p.lineTo(M[0] - t[0] * L, M[1] - t[1] * L);
      p.lineTo(M[0] - t[0] * L + side * n[0] * L, M[1] - t[1] * L + side * n[1] * L); p.lineTo(M[0] + t[0] * L + side * n[0] * L, M[1] + t[1] * L + side * n[1] * L); p.closePath(); return p;
    }
    var fxc = null;
    function finishCanvas(now) {
      var R = P.rect, W = Math.round(R.w * P.dpr), H = Math.round(R.h * P.dpr);
      if (!fxc || fxc.width !== W || fxc.height !== H) fxc = mk(W, H);
      var x = fxc.getContext('2d'); x.globalCompositeOperation = 'source-over'; x.globalAlpha = 1; x.clearRect(0, 0, W, H);
      x.drawImage(P.img, 0, 0, W, H);
      var cx = W / 2, cy = H / 2, Rr = Math.hypot(W, H) / 2, ang = Math.atan2(P.ly, P.lx) + Math.PI / 4, dx = Math.cos(ang) * Rr, dy = Math.sin(ang) * Rr;
      if (S.finish === 'holographic') {
        var sh = (P.lx + P.ly) * 0.5, g = x.createLinearGradient(cx - dx, cy - dy, cx + dx, cy + dy), hues = ['#9ff0ff', '#c9b6ff', '#ffb3e1', '#fff0a6', '#adffcf', '#9ff0ff', '#c9b6ff', '#ffb3e1'];
        hues.forEach(function (h, i) { g.addColorStop(clamp(i / (hues.length - 1) * 0.8 + 0.1 + sh * 0.25, 0, 1), h); });
        x.globalCompositeOperation = 'multiply'; x.globalAlpha = 0.9; x.fillStyle = g; x.fillRect(0, 0, W, H); x.globalAlpha = 1;
        if (!P.sparkle) { P.sparkle = mk(256, 256); var sx = P.sparkle.getContext('2d'); for (var i = 0; i < 520; i++) { var a = Math.random(); sx.fillStyle = 'rgba(255,255,255,' + (0.25 + a * 0.75) + ')'; sx.fillRect(Math.random() * 256, Math.random() * 256, a > 0.97 ? 2 : 1, a > 0.97 ? 2 : 1); } }
        x.globalCompositeOperation = 'screen'; x.globalAlpha = 0.35 + 0.35 * Math.abs(Math.sin(P.lx * 3 + P.ly * 2));
        var pat = x.createPattern(P.sparkle, 'repeat'); if (pat.setTransform) pat.setTransform(new DOMMatrix([1, 0, 0, 1, P.lx * 40, P.ly * 40]));
        x.fillStyle = pat; x.fillRect(0, 0, W, H); x.globalAlpha = 1;
      }
      if (S.finish !== 'matte') {
        var bx = cx + P.lx * Rr * 1.2, by = cy + P.ly * Rr * 1.2, nx = Math.cos(ang + Math.PI / 2) * Rr * 0.5, ny = Math.sin(ang + Math.PI / 2) * Rr * 0.5, a2 = S.finish === 'glossy' ? 0.55 : 0.45;
        var band = x.createLinearGradient(bx - nx, by - ny, bx + nx, by + ny);
        band.addColorStop(0, 'rgba(255,255,255,0)'); band.addColorStop(0.47, 'rgba(255,255,255,' + a2 + ')'); band.addColorStop(0.53, 'rgba(255,255,255,' + a2 + ')'); band.addColorStop(1, 'rgba(255,255,255,0)');
        x.globalCompositeOperation = 'screen'; x.fillStyle = band; x.fillRect(0, 0, W, H);
      } else {
        var soft = x.createRadialGradient(cx + P.lx * Rr, cy + P.ly * Rr, 0, cx, cy, Rr * 1.6);
        soft.addColorStop(0, 'rgba(255,255,255,.14)'); soft.addColorStop(1, 'rgba(0,0,0,.05)');
        x.globalCompositeOperation = 'soft-light'; x.fillStyle = soft; x.fillRect(0, 0, W, H);
      }
      x.globalCompositeOperation = 'destination-in'; x.globalAlpha = 1; x.drawImage(P.img, 0, 0, W, H);
      x.globalCompositeOperation = 'source-over';
      return fxc;
    }
    function drawMat() {
      var c = pctx, W = P.W, H = P.H, ppi = P.rect.ppi, ox = P.rect.x, oy = P.rect.y;
      c.fillStyle = '#eaf1f9'; c.fillRect(0, 0, W, H);
      function grid(step, col) { if (step < 5) return; c.beginPath(); c.strokeStyle = col; c.lineWidth = 1; for (var x = ox - Math.ceil(ox / step) * step; x < W; x += step) { c.moveTo(Math.round(x) + 0.5, 0); c.lineTo(Math.round(x) + 0.5, H); } for (var y = oy - Math.ceil(oy / step) * step; y < H; y += step) { c.moveTo(0, Math.round(y) + 0.5); c.lineTo(W, Math.round(y) + 0.5); } c.stroke(); }
      grid(ppi / 4, 'rgba(40,147,242,.08)'); grid(ppi, 'rgba(40,147,242,.2)');
    }
    function frame(now) {
      P.raf = 0; if (pv.hidden) return;
      if (now - P.last > 2200) { var tt = (now - P.t0) / 1000; P.tlx = Math.sin(tt * 0.7) * 0.8; P.tly = Math.cos(tt * 0.45) * 0.5; }
      P.lx += (P.tlx - P.lx) * 0.12; P.ly += (P.tly - P.ly) * 0.12;
      if (P.anim) P.anim(now);
      var c = pctx; c.setTransform(P.dpr, 0, 0, P.dpr, 0, 0);
      drawMat();
      var R = P.rect, e = clamp((now - P.enter) / 420, 0, 1), sc = 1 + (1 - (1 - Math.pow(1 - e, 3))) * 0.22;
      c.save(); c.translate(R.x + R.w / 2, R.y + R.h / 2); c.rotate((1 - e) * -0.12); c.scale(sc, sc); c.translate(-(R.x + R.w / 2), -(R.y + R.h / 2)); c.globalAlpha = e;
      c.save(); c.shadowColor = 'rgba(16,40,80,.25)'; c.shadowBlur = 20; c.shadowOffsetY = 9; c.drawImage(P.sil, R.x, R.y, R.w, R.h); c.restore();
      var body = finishCanvas(now), C = corner(), F = [P.fx, P.fy], d = Math.hypot(C[0] - F[0], C[1] - F[1]);
      if (P.peel < 0.5 || d < 4) c.drawImage(body, R.x, R.y, R.w, R.h);
      else {
        var M = [(C[0] + F[0]) / 2, (C[1] + F[1]) / 2], n = [(C[0] - F[0]) / d, (C[1] - F[1]) / d];
        c.save(); c.clip(halfPlane(M, n, 1)); c.drawImage(P.liner, R.x, R.y, R.w, R.h); c.restore();
        c.save(); c.clip(halfPlane(M, n, -1)); c.drawImage(body, R.x, R.y, R.w, R.h); c.restore();
        var a = 1 - 2 * n[0] * n[0], b = -2 * n[0] * n[1], dd = 1 - 2 * n[1] * n[1], mn = M[0] * n[0] + M[1] * n[1];
        // flap: the lifted part, mirrored across the fold, showing the adhesive back (drawn on its own layer so the shading stays on the flap)
        if (!P.flap || P.flap.width !== pcv.width || P.flap.height !== pcv.height) P.flap = mk(pcv.width, pcv.height);
        var fl = P.flap.getContext('2d');
        fl.setTransform(1, 0, 0, 1, 0, 0); fl.globalCompositeOperation = 'source-over'; fl.clearRect(0, 0, P.flap.width, P.flap.height);
        fl.save(); fl.setTransform(P.dpr * a, P.dpr * b, P.dpr * b, P.dpr * dd, P.dpr * 2 * mn * n[0], P.dpr * 2 * mn * n[1]);
        fl.clip(halfPlane(M, n, 1)); fl.drawImage(P.back, R.x, R.y, R.w, R.h);
        var g = fl.createLinearGradient(M[0], M[1], M[0] + n[0] * d / 2, M[1] + n[1] * d / 2); g.addColorStop(0, 'rgba(110,120,135,.4)'); g.addColorStop(0.45, 'rgba(255,255,255,0)');
        fl.globalCompositeOperation = 'source-atop'; fl.fillStyle = g; fl.fillRect(R.x - R.w, R.y - R.h, R.w * 3, R.h * 3); fl.restore();
        c.save(); c.setTransform(1, 0, 0, 1, 0, 0); c.shadowColor = 'rgba(10,30,60,.3)'; c.shadowBlur = 14 * P.dpr; c.drawImage(P.flap, 0, 0); c.restore();
      }
      c.restore();
      loop();
    }
    function loop() { if (!P.raf && !pv.hidden && !document.hidden) P.raf = requestAnimationFrame(frame); }
    function demoPeel() {
      if (pv.hidden) return;
      var C = corner(), T = [C[0] - P.rect.w * 0.42, C[1] - P.rect.h * 0.34], st = performance.now();
      P.peel = 1;
      P.anim = function (now) {
        var t = (now - st) / 1700, e = t < 0.45 ? Math.sin(t / 0.45 * Math.PI / 2) : t < 0.7 ? 1 : Math.cos((t - 0.7) / 0.3 * Math.PI / 2);
        e = clamp(e, 0, 1); P.fx = C[0] + (T[0] - C[0]) * e; P.fy = C[1] + (T[1] - C[1]) * e;
        if (t >= 1) { P.anim = null; P.peel = 0; P.fx = C[0]; P.fy = C[1]; }
      };
    }
    function ppos(e) { var r = pcv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
    pcv.addEventListener('pointerdown', function (e) {
      var p = ppos(e), C = corner(), R = P.rect;
      var inside = p[0] > R.x && p[0] < R.x + R.w && p[1] > R.y && p[1] < R.y + R.h;
      if (Math.hypot(p[0] - C[0], p[1] - C[1]) < Math.max(60, R.w * 0.25) || inside) { P.drag = true; P.anim = null; P.peel = 1; P.fx = p[0]; P.fy = p[1]; pcv.setPointerCapture(e.pointerId); }
    });
    pcv.addEventListener('pointermove', function (e) {
      var p = ppos(e);
      if (P.drag) { var C = corner(), d = Math.hypot(C[0] - p[0], C[1] - p[1]), mx = Math.hypot(P.rect.w, P.rect.h) * 1.6, f = d > mx ? mx / d : 1; P.fx = C[0] + (p[0] - C[0]) * f; P.fy = C[1] + (p[1] - C[1]) * f; return; }
      if (e.pointerType === 'mouse') { P.tlx = p[0] / P.W * 2 - 1; P.tly = p[1] / P.H * 2 - 1; P.last = performance.now(); }
    });
    function release() {
      if (!P.drag) return; P.drag = false;
      var C = corner(), x0 = P.fx, y0 = P.fy, st = performance.now();
      P.anim = function (now) { var t = clamp((now - st) / 420, 0, 1), e = 1 - Math.pow(1 - t, 3); P.fx = x0 + (C[0] - x0) * e; P.fy = y0 + (C[1] - y0) * e; if (t >= 1) { P.anim = null; P.peel = 0; } };
    }
    pcv.addEventListener('pointerup', release); pcv.addEventListener('pointercancel', release);
    $('#smxPvX').onclick = closePreview;
    $('#smxPvPeel').onclick = demoPeel;
    $('#smxPvFin').onclick = function (e) {
      var b = e.target.closest('button[data-f]'); if (!b) return;
      var real = document.querySelector('.sms-finish-btn[data-finish="' + b.dataset.f + '"]');
      if (real) real.click(); else S.finish = b.dataset.f;
      syncFin();
    };
    if (window.DeviceOrientationEvent && isTouch) {
      var tb = $('#smxPvTilt'); tb.hidden = false;
      tb.onclick = function () {
        var go = function () { window.addEventListener('deviceorientation', function (ev) { if (ev.gamma == null) return; P.tlx = clamp(ev.gamma / 30, -1, 1); P.tly = clamp((ev.beta - 45) / 30, -1, 1); P.last = performance.now(); }); tb.classList.add('on'); };
        if (typeof DeviceOrientationEvent.requestPermission === 'function') DeviceOrientationEvent.requestPermission().then(function (r) { if (r === 'granted') go(); }).catch(function () { }); else go();
      };
    }
    window.addEventListener('resize', function () { if (!pv.hidden) sizePv(); });
    $('#smxPeelT').onclick = openPreview;

    // ── PRICE PANEL: qty nudge + arrival date + print check ──────────────────
    var priceTop = document.querySelector('.sms-price-box > div');
    var extra = el('<div class="smx-extra"><button class="smx-nudge" id="smxNudge" hidden></button></div>');
    if (priceTop) priceTop.parentNode.insertBefore(extra, priceTop.nextSibling);
    function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w !== 6) n--; } return d; }
    function arrival() { var f = { weekday: 'short', month: 'short', day: 'numeric' }; return addBiz(new Date(), +CFG.productionDays + +CFG.shipMin).toLocaleDateString('en-US', f) + ' – ' + addBiz(new Date(), +CFG.productionDays + +CFG.shipMax).toLocaleDateString('en-US', f); }
    function qtyOptions() { return $$('.sms-qty-pre').map(function (b) { return +b.dataset.qty; }).sort(function (a, b) { return a - b; }); }
    function renderPriceExtras() {
      var nb = $('#smxNudge'); if (!nb) return;
      if (S.shape === 'dtf' && !window.DTF) { nb.hidden = true; return; }
      var cur = SMN.price(S.sizeInches, S.finish, S.qty), all = cur;
      if (window.DTF && cur.sheet) cur = cur.sheet;
      nb.hidden = true;
      if (window.DTF && all.emptyOpen) return;
      if (cur.label || !cur.unit) return;
      var qs = qtyOptions();
      for (var i = 0; i < qs.length; i++) {
        if (qs[i] <= S.qty) continue;
         // respect the size/quantity rule
        var np = SMN.price(S.sizeInches, S.finish, qs[i]);
        if (window.DTF && np.sheet) np = np.sheet;
        if (np.unit < cur.unit * 0.99) { nb.hidden = false; nb.dataset.q = qs[i]; nb.textContent = 'Get ' + qs[i] + (window.DTF ? ' copies' + (all.sheets > 1 ? ' of this sheet' : '') : '') + ' for ' + money(np.total) + ' (' + money(np.unit) + ' each, ' + Math.round((1 - np.unit / cur.unit) * 100) + '% less per sheet)'; }
        break;
      }
    }
    $('#smxNudge') && ($('#smxNudge').onclick = function () { var b = document.querySelector('.sms-qty-pre[data-qty="' + this.dataset.q + '"]'); if (b) b.click(); });
    var tp = document.getElementById('totalPriceLg');
    if (tp) new MutationObserver(renderPriceExtras).observe(tp, { childList: true, characterData: true, subtree: true });
    (function () {
      var qn = document.getElementById('dtfQtyN'); if (!qn || qn._smxWired) return; qn._smxWired = 1;
      function show() { if (document.activeElement !== qn) qn.value = S.qty; }
      qn.addEventListener('change', function () {
        var v = clamp(parseInt(qn.value, 10) || 1, 1, 999); qn.value = v;
        if (v === S.qty) return;
        var pre = document.querySelector('.sms-qty-pre[data-qty="' + v + '"]');
        if (pre) { pre.click(); return; }
        S.qty = v; $$('.sms-qty-pre').forEach(function (b) { b.classList.toggle('active', +b.dataset.qty === v); });
        if (window.DTF && DTF.refresh) DTF.refresh(); else SMN.updatePrice();
      });
      qn.addEventListener('keydown', function (e) { if (e.key === 'Enter') qn.blur(); });
      qn.addEventListener('blur', show);
      if (tp) new MutationObserver(show).observe(tp, { childList: true, characterData: true, subtree: true });
      show();
    })();
    // print check list, shown inside the "Approve your proof" window
    function computeChecks() {
      if (window.DTF && S.shape === 'dtf') return Promise.resolve(DTF.worstDpiAll ? DTF.worstDpiAll() : (DTF.worstDpi ? DTF.worstDpi() : Infinity)).then(function (wd) {
        var o2 = []; if (isFinite(wd) && Math.round(wd) >= 250) o2.push(['ok', (wd >= 299.5 ? 'Sharp print · 300 DPI' : 'Good print · ' + Math.round(wd) + ' DPI') + ' at print size']); return o2;
      }, function () { return []; });
      var ls = userLayers(), lip = SMN.lip && SMN.lip();
      if (!ls.length || !lip || !lip.width) return [];
      var inPerPx = (S.sizeInches || 2) / Math.max(lip.width, lip.height), out = [], worst = Infinity;
      ls.forEach(function (o) {
        if (o.type === 'image' && o.getElement && !o._isTemplateBg) {
          var e = o.getElement(), nat = e.naturalWidth || e.width, inches = o.getScaledWidth() * inPerPx;
          if (inches > 0.05) worst = Math.min(worst, nat / inches);
        }
      });
      // under 150 dpi the proof window already shows its own warning, so only add the good/soft cases
      if (isFinite(worst)) {
        if (worst >= 300) out.push(['ok', 'Sharp print · ' + Math.round(worst) + ' dpi']);
        else if (worst >= 150) out.push(['warn', 'Image is ' + Math.round(worst) + ' dpi at this size. It may look slightly soft.']);
      }
      var tiny = ls.some(function (o) { return /text/.test(o.type) && (o.fontSize || 0) * (o.scaleY || 1) * inPerPx * 72 < 7; });
      if (tiny) out.push(['warn', 'Some text is smaller than 7 pt and may be hard to read.']);
      return out;
    }
    renderPriceExtras();
    var origProof = window._sl2Proof;
    if (typeof origProof === 'function') {
      window._sl2Proof = async function () {
        var checks = computeChecks(), res = await origProof.apply(this, arguments);
        checks = await checks;
        var ol = document.getElementById('sl2-proof-ol'), specs = ol && ol.querySelector('.sl2-proof-specs');
        if (specs && !ol.querySelector('.smx-proof-info')) {
          var rows = checks.map(function (c) { return '<li class="smx-ck ' + c[0] + '">' + ic(c[0] === 'ok' ? 'check' : 'warn') + '<span>' + esc(c[1]) + '</span></li>'; });
          if (!window.DTF) rows.push('<li class="smx-ck ship">' + ic('truck') + '<span><b>Free shipping</b> · arrives ' + esc(arrival()) + '</span></li>');
          specs.parentNode.insertBefore(el('<ul class="smx-checks smx-proof-info">' + rows.join('') + '</ul>'), specs);
        }
        return res;
      };
    }

    // ── paste, drop anywhere, HEIC guard ─────────────────────────────────────
    function isHeic(f) { return f && (/hei[cf]/i.test(f.type) || /\.hei[cf]$/i.test(f.name || '')); }
    function takeFile(f) {
      if (!f) return;
      if (isHeic(f)) return toast('iPhone HEIC photos aren’t supported yet. Share it as a JPG or PNG and try again.', 'warn');
      if (!/^image\//.test(f.type)) return toast('That file isn’t an image. Use PNG, JPG, SVG or WebP.', 'warn');
      if (window.DTF) return DTF.addFiles([f]);
      if (SMN.vo().length) SMN.addImage(f); else SMN.loadImage(f);
    }
    document.addEventListener('change', function (e) {
      var t = e.target; if (window.DTF || !t || t.type !== 'file' || !t.files || !t.files[0]) return;
      if (isHeic(t.files[0])) { e.stopPropagation(); t.value = ''; toast('iPhone HEIC photos aren’t supported yet. Share it as a JPG or PNG and try again.', 'warn'); }
    }, true);
    document.addEventListener('paste', function (e) {
      var tag = e.target && e.target.tagName; if (tag === 'INPUT' || tag === 'TEXTAREA' || (e.target && e.target.isContentEditable)) return;
      var items = (e.clipboardData && e.clipboardData.items) || [];
      for (var i = 0; i < items.length; i++) if (items[i].type.indexOf('image') === 0) { e.preventDefault(); takeFile(items[i].getAsFile()); toast('Pasted from clipboard.', 'ok'); return; }
    });
    var cover = el('<div class="smx-drop"><span>Drop to add</span></div>'); area.appendChild(cover);
    var depth = 0;
    area.addEventListener('dragenter', function (e) { if (e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types, 'Files') > -1) { depth++; cover.classList.add('on'); } });
    area.addEventListener('dragleave', function () { depth = Math.max(0, depth - 1); if (!depth) cover.classList.remove('on'); });
    area.addEventListener('dragover', function (e) { e.preventDefault(); });
    area.addEventListener('drop', function (e) {
      depth = 0; cover.classList.remove('on');
      if (e.defaultPrevented) return;
      e.preventDefault(); var f = e.dataTransfer.files && e.dataTransfer.files[0]; takeFile(f);
    });

    // ── keyboard shortcuts ───────────────────────────────────────────────────
    var nudgeT = 0, nudgeF = null;
    function flushNudge() { clearTimeout(nudgeT); var f = nudgeF; nudgeF = null; if (f) f(); }
    document.addEventListener('click', function (e) { if (nudgeF && e.target.closest && e.target.closest('#btnUndo, #btnRedo')) flushNudge(); }, true);
    document.addEventListener('keydown', function (e) {
      if (!pv.hidden && e.key === 'Escape') { closePreview(); return; }
      if (!cal.hidden && e.key === 'Escape') { cal.hidden = true; return; }
      if (open && e.key === 'Escape') { open = false; lp.classList.remove('open'); $('#smxLayersH').setAttribute('aria-expanded', 'false'); e.preventDefault(); return; }
      var tag = document.activeElement && document.activeElement.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      var c = S.canvas; if (!c) return;
      var o = c.getActiveObject(), mod = e.ctrlKey || e.metaKey;
      if (o && o.isEditing) return;
      if (mod && /^[zy]$/i.test(e.key)) flushNudge();
      if (mod && e.key.toLowerCase() === 'z') { e.preventDefault(); var b = document.getElementById(e.shiftKey ? 'btnRedo' : 'btnUndo'); if (b && !b.classList.contains('disabled')) b.click(); return; }
      if (mod && e.key.toLowerCase() === 'y') { e.preventDefault(); var r = document.getElementById('btnRedo'); if (r && !r.classList.contains('disabled')) r.click(); return; }
      if (e.key === 'Escape' && o) { c.discardActiveObject(); SMN.lockAll(); c.renderAll(); return; }
      if (o && /^Arrow/.test(e.key) && o.selectable !== false) {
        e.preventDefault(); var st = e.shiftKey ? 10 : 1;
        if (e.key === 'ArrowLeft') o.left -= st; if (e.key === 'ArrowRight') o.left += st; if (e.key === 'ArrowUp') o.top -= st; if (e.key === 'ArrowDown') o.top += st;
        o.setCoords(); c.renderAll(); clearTimeout(nudgeT); nudgeF = function () { if (c === S.canvas && (o.type === 'activeSelection' || c.getObjects().indexOf(o) > -1)) c.fire('object:modified', { target: o }); }; nudgeT = setTimeout(flushNudge, 350);
      }
    });

    // ── LIVE CO-EDITING ──────────────────────────────────────────────────────
    // Everyone with the link edits the same design. Each open copy polls the shared save every 4 s and pulls a
    // collaborator's newer version, but never while you are dragging, typing, in a dialog, or have an unsaved edit.
    var live = el('<div class="smx-live" id="smxLive" hidden><span class="smx-dot"></span><span id="smxLiveT">Shared · live</span></div>');
    area.appendChild(live);

    // ── ONE TOP BAR over the canvas: layers · view tools · live · zoom · invite · download ──
    // (these used to float separately in the corners; the Start Over float is gone — Reset in the Edit tools does that)
    var bar = el('<div class="smn-bar" id="smnBar" role="toolbar" aria-label="Design tools" hidden><div class="smn-bar-l"></div><div class="smn-bar-r"></div></div>');
    var skyMain = document.querySelector('.ds-dock-main');
    if (skyMain) skyMain.insertBefore(bar, skyMain.querySelector('.ds-help')); else area.appendChild(bar);
    var barL = bar.firstChild, barR = bar.lastChild;
    if (!document.querySelector('.ds-layers-side')) barL.appendChild(lp); barL.appendChild(tools);
    ['smxLive', 'smsZoomControls', 'btnShareLink', 'btnDownload'].forEach(function (id) { var e = document.getElementById(id); if (e) barR.appendChild(e); });
    // Layers becomes a dropdown in the bar: closed by default, closes when you click elsewhere
    open = false; lp.classList.remove('open'); $('#smxLayersH').setAttribute('aria-expanded', 'false');
    document.addEventListener('pointerdown', function (e) {
      if (open && !lp.contains(e.target)) { open = false; lp.classList.remove('open'); $('#smxLayersH').setAttribute('aria-expanded', 'false'); }
    }, true);
    function fitBar() {
      bar.style.top = chromeTop() + 'px';
      var any = Array.prototype.some.call(bar.querySelectorAll('.smn-bar-l > *, .smn-bar-r > *'), function (x) { return !x.hidden && getComputedStyle(x).display !== 'none'; });
      bar.hidden = !any;
      // too narrow for the labels → icons only (instead of buttons clipping each other)
      bar.classList.remove('smn-compact');
      if (!bar.hidden && (bar.scrollWidth > bar.clientWidth + 1 || barL.scrollWidth > barL.clientWidth + 1)) bar.classList.add('smn-compact');
    }
    setInterval(fitBar, 400); window.addEventListener('resize', fitBar); fitBar();
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#sl2StartDesigning, #sl2SpecsPill')) { fitBar(); setTimeout(fitBar, 0); } });
    var lastLocal = 0, lastOther = 0, pointerDown = false, polling = false;
    document.addEventListener('pointerdown', function () { pointerDown = true; }, true);
    document.addEventListener('pointerup', function () { pointerDown = false; lastLocal = Date.now(); }, true);
    // real edits only (the add-on's own periodic refresh must not count as the user editing)
    var editBound = null;
    setInterval(function () {
      var c = S.canvas; if (!c || c === editBound) return; editBound = c;
      ['object:modified', 'object:added', 'object:removed', 'text:changed'].forEach(function (ev) { c.on(ev, function () { if (!applyingRemote) lastLocal = Date.now(); }); });
    }, 500);
    var applyingRemote = false;
    function userBusy() {
      var c = S.canvas, a = c && c.getActiveObject();
      if (pointerDown || (c && c._currentTransform)) return true;
      if (a && a.isEditing) return true;
      if (document.querySelector('.sms-modal-overlay, #sl2-proof-ol') ) return true;
      return Date.now() - lastLocal < 5000; // an edit of ours is still waiting for its autosave
    }
    function renderLive() {
      var sid = SMN.shareId && SMN.shareId(); live.hidden = !sid;
      var recent = Date.now() - lastOther < 120000;
      live.classList.toggle('on', recent);
      $('#smxLiveT').textContent = recent ? 'Collaborator editing' : 'Shared · live';
      live.style.top = (parseFloat(lp.style.top || '12') + (lp.hidden ? 0 : lp.offsetHeight + 8)) + 'px';
    }
    var firstSnap = false;
    setInterval(async function () {
      renderLive();
      if (!firstSnap && SMN.shareId && SMN.shareId() && S.canvas && designObjs().length) { firstSnap = true; snapshot(); }
      var sid = SMN.shareId && SMN.shareId();
      if (!sid || !S.canvas || polling || document.hidden || userBusy() || window._smnNoAutosave) return; // paused while a sheet sticker is edited
      polling = true;
      try {
        var r = await fetch('https://print-api.stickermint.workers.dev/share/' + sid + '?t=' + Date.now(), { cache: 'no-store' });
        if (r.ok) {
          var j = await r.json();
          if (j && j._rev && j._by && j._by !== window._smnClientId && j._rev > (window._smnLastRev || 0) && !userBusy()) { applyingRemote = true; SMN.applyRemote(sameSheet(j), false); setTimeout(function () { applyingRemote = false; }, 1500); }
        }
      } catch (e) { }
      polling = false;
    }, 4000);
    // stable ids for every design element (kept in the shared save) + a snapshot of what was last in sync
    var UIDP = ['_uid', '_isMainImage', '_isTemplateBg', '_dtfNat','_dtfOrig','_dtfName','_dtfSemi','_dtfAlpha','_dtfBox','_dtfKey','_dtfBase','_dtfBg','_dtfEnh','_dtfPlaced','_dtfNorm','_dtfLock','_dtfGap'];
    function uidOf(o) { if (!o._uid) o._uid = Date.now().toString(36) + Math.random().toString(36).slice(2, 7); return o._uid; }
    function designObjs() { return S.canvas ? S.canvas.getObjects().filter(function (o) { return !o._isCutline && !o._isCutEdge && !o._isScissorIcon; }) : []; }
    var synced = {};
    function ser(o) { return S.canvas && S.canvas._toObject ? S.canvas._toObject(o, 'toObject', UIDP) : o.toObject(UIDP); }
    function snapshot() { synced = {}; designObjs().forEach(function (o) { synced[uidOf(o)] = JSON.stringify(ser(o)); }); }
    setInterval(function () { designObjs().forEach(uidOf); }, 600);
    document.addEventListener('smn:saved', snapshot);
    // Conflict: someone saved after our last sync. Start from their version, re-apply what WE added/changed/deleted.
    function dtfActive() { try { return window.DTF ? (DTF.activeIndex ? DTF.activeIndex() : DTF.kit().D().active) : -1; } catch (e) { return -1; } }
    function sameSheet(remote) {
      var la = dtfActive(), rd = remote && remote.dtf;
      if (typeof la !== 'number' || la < 0 || !rd || !rd.sheets || !rd.sheets[la] || (rd.active | 0) === la) return remote;
      var ra = rd.active | 0, rs = rd.sheets.map(function (x) { return Object.assign({}, x); });
      if (rs[ra]) rs[ra].json = { objects: (remote.canvas && remote.canvas.objects) || [] };
      var base = rs[la].json && rs[la].json.objects ? rs[la].json.objects : [];
      rs[la].json = null;
      return Object.assign({}, remote, { size: rs[la].size || remote.size, qty: rs[la].qty || remote.qty, dtf: Object.assign({}, rd, { sheets: rs, active: la }), canvas: Object.assign({}, remote.canvas, { objects: base }) });
    }
    SMN.mergeRemote = function (remote) {
      remote = sameSheet(remote);
      var mine = {}, order = [];
      designObjs().forEach(function (o) { var u = uidOf(o); mine[u] = ser(o); order.push(u); });
      var changed = {}, added = [], deleted = {};
      order.forEach(function (u) { if (!(u in synced)) added.push(u); else if (JSON.stringify(mine[u]) !== synced[u]) changed[u] = true; });
      Object.keys(synced).forEach(function (u) { if (!(u in mine)) deleted[u] = true; });
      var objs = (remote.canvas.objects || []).filter(function (o) { return !o._isCutline && !o._isCutEdge && !o._isScissorIcon && !deleted[o._uid]; })
        .map(function (o) { return o._uid && changed[o._uid] ? mine[o._uid] : o; });
      var have = {}; objs.forEach(function (o) { if (o._uid) have[o._uid] = 1; });
      added.forEach(function (u) { if (!have[u]) objs.push(mine[u]); });
      Object.keys(changed).forEach(function (u) { if (!have[u]) objs.push(mine[u]); });
      var merged = Object.assign({}, remote, { canvas: Object.assign({}, remote.canvas, { objects: objs }) });
      var nMine = added.length + Object.keys(changed).length + Object.keys(deleted).length;
      applyingRemote = true;
      SMN.applyRemote(merged, false);
      setTimeout(function () { applyingRemote = false; if (nMine) { try { SMN.save(); } catch (e) { } } }, 1200);
      toast(nMine ? 'Merged your changes with your collaborator’s.' : 'Updated with your collaborator’s latest changes.', 'ok');
      return true;
    };
    document.addEventListener('smn:remote', function (e) {
      if (window._smnSheetLoad) return; // the sticker-sheet editor loading one of its own designs
      lastOther = Date.now(); lastLocal = 0; listSig = ''; renderLive(); bump(); setTimeout(snapshot, 300);
      toast(e.detail && e.detail.conflict ? 'A collaborator saved changes at the same moment. Their version is loaded, so redo your last change if it is missing.' : 'Updated with your collaborator’s latest changes.', e.detail && e.detail.conflict ? 'warn' : 'ok');
    });
    // Share button: say what it does, and show the link (clipboard can be blocked)
    (function () {
      var sb = document.getElementById('btnShareLink'); if (!sb) return;
      sb.title = 'Invite someone to design this gang sheet with you';
      var t = document.getElementById('btnShareText'); if (t && /share/i.test(t.textContent)) t.textContent = 'Invite';
      sb.addEventListener('click', function () {
        setTimeout(function () {
          var url = window._smnShareUrl; if (!url) return;
          toast('Invite link copied. Anyone with it can edit this gang sheet with you, live.', 'ok', { label: 'Show link', fn: function () { window.prompt('Share this link:', url); } });
          renderLive();
        }, 400);
      });
    })();

    // custom die-cut sizes fit the design inside the W x H box, so the real longest side changes with the art
    setInterval(function () {
      if (S.size !== 'custom' || S.shape !== 'die-cut' || !S.canvas || !SMN.vo().length || !SMN.customInches) return;
      var v = SMN.customInches();
      if (v > 0 && Math.abs(v - (S.sizeInches || 0)) > 0.02) { S.sizeInches = v; try { SMN.updatePrice(); SMN.updateDimLabel(); } catch (e) { } }
    }, 700);
    // borders are physical (mm) now, so a size change needs a fresh cut line
    var lastSize = S.sizeInches, sizeT = 0;
    setInterval(function () {
      if (S.sizeInches === lastSize) return;
      lastSize = S.sizeInches; clearTimeout(sizeT);
      sizeT = setTimeout(function () { if (S.canvas && S.shape === 'die-cut' && SMN.vo().length) { try { SMN.drawCutline(); } catch (e) { } } }, 350);
    }, 300);

    bump();
  }
  if (window.SMN) start(); else document.addEventListener('smn:ready', start, { once: true });
})();
